import { Heading } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { AutoscrollSwiper } from '@/widgets/Sliders';
import { DefaultContainer } from '@/shared/ui';
import { getUseCases } from '../lib/useCases';
import UseCaseCard from './UseCaseCard';

const UseCaseBlock = () => {
  const { t } = useTranslation();
  const useCases = getUseCases(t);

  return (
    <DefaultContainer
      containerProps={{
        _odd: {
          bg: 'bg.light',
        },
      }}
    >
      <Heading
        alignSelf='center'
        mb='2xl'
        size={{ base: 'xl', md: '2xl' }}
      >
        {t('store.product.useCases.heading')}
      </Heading>

      <AutoscrollSwiper
        slides={useCases?.map?.((item) => (
          <UseCaseCard
            {...item}
            key={item.title}
          />
        ))}
      />
    </DefaultContainer>
  );
};

export default UseCaseBlock;
